import type { FC, SVGProps } from 'react'

export const Remix: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.19556 13.1818H1V12.1091H2.19556C3.35266 12.1091 4.41314 11.6182 5.10739 10.7455L6.01373 11.4C5.10739 12.5273 3.6997 13.1818 2.19553 13.1818H2.19556ZM6.84297 4.56369L7.74931 5.21823C8.44353 4.36369 9.50418 3.89099 10.6419 3.89099H12.821L11.7025 4.94553L12.5125 5.70917L15 3.36379L12.5125 1L11.7025 1.76363L12.821 2.81817H10.6226C9.13775 2.81817 7.74931 3.4546 6.843 4.56369H6.84297ZM12.5124 15L15 12.6546L12.5124 10.2908L11.7025 11.0545L12.821 12.109H10.6226C8.61715 12.109 6.97796 10.5635 6.97796 8.67266V7.16358C6.88151 4.76352 4.76038 2.83632 2.19556 2.83632H1V3.90901H2.19556C4.20101 3.90901 5.84021 5.45452 5.84021 7.34536V8.85444C5.93666 11.2545 8.05778 13.1817 10.6226 13.1817L12.821 13.1818L11.7025 14.2364L12.5124 15Z"
      fill="currentColor"
    />
  </svg>
)
